import { gql } from '@apollo/client';
import { MinAssemblyFieldsFragment } from '../assembly/fragments';
import { PlaylistFieldsFragment } from '../playlist/fragments';
import { MinResourceFragmentFields } from '../resource/fragments';
import {
  MinSongFieldsFragment,
  SparklesFieldsFragment,
} from '../song/fragments';
import { EsongbookFieldsFragments } from '../songbook/fragments';

export const CollectionFieldsFragment = gql`
  fragment CollectionFields on Collection {
    id
    title
    pdfs
    videos
    description
    isUserCollection
    image
    albumArts
    songs {
      ...MinSongFields
    }
    sparkles {
      ...SparklesFields
    }
    resources {
      ...MinResourceFields
    }
    playlists {
      ...PlaylistFields
    }
    esongbooks {
      ...EsongbookFields
    }
    assemblies {
      ...MinAssemblyFields
    }
    # assemblyPlans {
    #   ...AssemblyPlanFields
    # }
  }
  ${SparklesFieldsFragment}
  ${EsongbookFieldsFragments}
  ${MinSongFieldsFragment}
  ${MinResourceFragmentFields}
  ${PlaylistFieldsFragment}
  ${MinAssemblyFieldsFragment}
`;

export const CollectionsFieldsFragment = gql`
  fragment CollectionsFields on Collection {
    id
    title
    pdfs
    isUserCollection
    image
    albumArts
    songs {
      ...MinSongFields
    }
    resources {
      id
    }
    assemblies {
      id
    }
    esongbooks {
      id
    }
    playlists {
      id
    }
  }
  ${MinSongFieldsFragment}
`;

export const MinCollectionFieldsFragment = gql`
  fragment MinCollectionFields on Collection {
    id
    title
    isUserCollection
    image
    albumArts
  }
`;

export const CollectionShareLinkFieldsFragment = gql`
  fragment CollectionShareLinkFields on CollectionShareLink {
    id
    uuid
    userId
    collectionId
  }
`;
